// extracted by mini-css-extract-plugin
module.exports = {"details":"style_details__2QDen","training-approve":"style_training-approve__1-DFE","input-container":"style_input-container__2hpUo"};